
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'PlusSVG',
})
export default class PlusSVG extends Vue {}
